module.exports = __webpack_public_path__ + "media/enterprise_powerlist/triangle-2801cd94.png";